import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Star, Users, TrendingUp, Sparkles } from "lucide-react";
import { PageHero, HeroGlassCard } from "@/components/shared/PageHero";

export const HeroSection = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  const ar = language === "ar";

  return (
    <PageHero
      eyebrow={ar ? "شبكة المؤثرين المتميزة" : "Premium influencer network"}
      title={ar ? "تواصل مع" : "Connect with"}
      accent={ar ? "أهم المؤثرين السعوديين" : "Top Saudi Influencers"}
      subtitle={t("influencerDescription")}
      ctas={[
        {
          label: t("bookInfluencer"),
          onClick: () => navigate("/influencer-booking"),
          icon: <Users className="w-4 h-4" />,
        },
        {
          label: ar ? "انضم كمؤثر" : "Become an Influencer",
          onClick: () => navigate("/influencer-signup"),
          variant: "secondary",
          icon: <Star className="w-4 h-4 text-primary" />,
        },
      ]}
      rightSlot={
        <HeroGlassCard>
          <div className="flex items-center justify-between mb-3">
            <div className="text-[10px] font-semibold text-white/70 uppercase tracking-widest">
              {ar ? "إحصائيات الشبكة" : "Network snapshot"}
            </div>
            <span className="px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-300 text-[9px] font-semibold">
              Live
            </span>
          </div>
          <div className="space-y-3">
            <div className="rounded-xl bg-white/5 border border-white/10 p-3">
              <div className="flex items-center gap-2 text-primary mb-1">
                <Users className="w-3.5 h-3.5" />
                <span className="text-[10px] font-semibold uppercase tracking-widest">{ar ? "مؤثرون موثوقون" : "Verified creators"}</span>
              </div>
              <div className="text-xs text-white/80">
                {ar
                  ? "نخبة من المؤثرين السعوديين عبر الجمال والسفر والطعام والتقنية والترفيه."
                  : "A curated roster of Saudi creators across beauty, travel, food, tech and entertainment."}
              </div>
            </div>
            <div className="rounded-xl bg-white/5 border border-white/10 p-3">
              <div className="flex items-center gap-2 text-primary mb-1">
                <TrendingUp className="w-3.5 h-3.5" />
                <span className="text-[10px] font-semibold uppercase tracking-widest">{ar ? "حملات قابلة للقياس" : "Measurable campaigns"}</span>
              </div>
              <div className="text-xs text-white/80">
                {ar
                  ? "تتبع مباشر لكل حجز، مع تقييم بعد كل حملة."
                  : "Live tracking on every booking, with a post-campaign rating on each one."}
              </div>
            </div>
            <div className="rounded-xl bg-primary/15 border border-primary/30 p-3">
              <div className="flex items-center gap-2 text-primary mb-1">
                <Sparkles className="w-3.5 h-3.5" />
                <span className="text-[10px] font-semibold uppercase tracking-widest">{ar ? "جودة موثقة" : "Verified quality"}</span>
              </div>
              <div className="text-xs text-white/80">
                {ar ? "كل مؤثر يحمل ترخيص موثوق ساري." : "Every creator carries a valid Mawthooq license."}
              </div>
            </div>
          </div>

        </HeroGlassCard>
      }
    />
  );
};
